exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".patient-register-description{font-size:30px;font-family:NanumBarunGothicOTF;text-align:center}.patient-register-input{width:451.4px;height:42px;line-height:42px;outline:none}.patient-register-enroll,.patient-register-input{font-size:18px;font-family:NanumBarunGothicOTF;margin:20px auto;display:block}.patient-register-enroll{width:283.7px;height:58px;border-radius:100px;box-shadow:0 3px 12px 0 #4b74ff;background-color:#4b74ff;font-style:normal;font-stretch:normal;line-height:58px;letter-spacing:normal;text-align:center;color:#fcfcfc;border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f491150","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DoctorCenter/PatientRegister.vue
// module id = 256
// module chunks = 0